// extracted by mini-css-extract-plugin
export default {"root":"EventsAttendeesItem_root__t+sym"};